import type { PanInfo } from "motion";

import { createContext, useContext } from "react";

import type { DragDestination, DragSource } from "./DragProvider";

export const DragContext = createContext<{
  dragSource: DragSource | null;
  dragPreview: DragDestination | null;
  handleDragStart: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void;
  handleDragMove: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void;
  handleDragEnd: () => void;
}>(null!);

export function useDragContext() {
  const ctx = useContext(DragContext);
  if (!ctx) throw new TypeError("Must be in DragContext");
  return ctx;
}
